import axios from 'axios'
const API_KEY = process.env.REACT_APP_CONTENT_API_KEY
const BASE_URL = process.env.REACT_APP_API_CONTENT_URL

async function contentData(endpoint) {
  try {
    const response = await axios.get(`${BASE_URL}/content/${endpoint}`, {
      headers: {
        api_key: API_KEY,
        //"Content-Type" : "application/json"
      },
    })
    response.data.success = true
    return response.data
  } catch (err) {
    return { success: false, message: err.response.data }
  }
}
export const pageData = async (pageName, lang) => {
  return contentData(`pages/${pageName}/${lang}`)
}
export const listData = async (listName, lang) => {
  return contentData(`lists/${listName}/${lang}`)
}
export const prisonsList = async (listvalue, lang, listKey) => {
  return contentData(`lists/${listvalue}/${lang}/${listKey}`)
}

export const getGoogleInfo = async (token) => {
  try {
    const url = `https://www.googleapis.com/oauth2/v1/userinfo?alt=json&access_token=${token}`
    const response = await axios.get(url)
    return response.data
  } catch (e) {
    return e.response ? e.response.data : e
  }
}
